/* eslint-disable */
export function initPopup() {
	wpcore.showPopup = function (target) {
		openPopup(target);
	};
	wpcore.closePopup = function (target) {
		closePopup(target);
	};
}

function openPopup(target) {
	const popup = document.getElementById(`popup-${target}`);
	if (!popup) return;

	// Move popup to body to escape sidebar stacking context
	if (popup.parentElement !== document.body) {
		document.body.appendChild(popup);
	}

	popup.classList.remove("hidden");
	popup.classList.add("flex");
	document.body.classList.add("overflow-hidden");

	// Dispatch event when popup opens
	document.dispatchEvent(
		new CustomEvent("popup-opened", { detail: { target } }),
	);

	// Bind close buttons (use once to avoid duplicate listeners)
	popup.querySelectorAll(".close-popup").forEach((btn) => {
		btn.addEventListener("click", () => closePopup(target), { once: true });
	});
}

function closePopup(target, callback = undefined) {
	const popup = document.getElementById(`popup-${target}`);
	if (!popup) return;

	popup.classList.remove("flex");
	popup.classList.add("hidden");
	document.body.classList.remove("overflow-hidden");

	document.dispatchEvent(
		new CustomEvent("popup-closed", { detail: { target } }),
	);

	if (callback) {
		callback();
	}
}
